export const SAVE_PRODUCT_OBJ = 'SAVE_PRODUCT_OBJ';

// 保存商品数据
export function saveProductObj(productObj) {
  return { type: SAVE_PRODUCT_OBJ, productObj };
}



// WEBPACK FOOTER //
// ./src/routes/routes/addProductShop/modules/actions.js